import React, { ChangeEvent, FC } from "react";

interface Props {
  label: string;
  value: boolean;
  inputAttrs?: any;
  onChange: (value: boolean) => void;
  errorMessage?: string;
}

export const FormCheck: FC<Props> = ({
  label,
  value,
  inputAttrs,
  onChange,
  errorMessage,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div>
      <label className="formCheck">
        <input
          type="checkbox"
          {...inputAttrs}
          checked={value}
          onChange={handleChange}
          className="sr-only"
        />
        <div className={`formCheck--box ${value ? "checked" : ""}`}>
          <div className="formCheck--box-check" />
        </div>
        <span className="formCheck--label">{label}</span>
      </label>
      {errorMessage && <span className="formCheck--error">{errorMessage}</span>}
    </div>
  );
};
